import { render, staticRenderFns } from "./organizatioDialog.vue?vue&type=template&id=5828a262&scoped=true&"
import script from "./organizatioDialog.vue?vue&type=script&lang=js&"
export * from "./organizatioDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5828a262",
  null
  
)

export default component.exports